import clsx from 'clsx';
import React, { ReactNode, useEffect } from 'react';

import { ChatInput } from '~/components/chat';
import { TrackingMetadata } from '~/services/tracking/posthog/constants';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';

import styles from './AlfredFooter.module.scss';

export const ALFRED_FOOTER_SPACER_HEIGHT_PX = 188;

export interface AlfredFooterProps {
  renderChatInput?: (override?: { cta?: ReactNode }) => ReactNode;
  selectedBadges?: ReactNode[];
  ctaLabel?: string;
  onCtaClick?: () => void;
  isCtaLoading?: boolean;
  shouldHide?: boolean;
  trackingMetadata?: TrackingMetadata;
  fixed?: boolean;
}

export const AlfredFooter = ({
  shouldHide = false,
  trackingMetadata,
  fixed = false,
}: AlfredFooterProps) => {
  const { mode, setMode, resetPreviousMode } = useChatNavigation();

  useEffect(() => {
    if (mode !== 'research') {
      setMode('research');
    }

    resetPreviousMode();
  }, []);

  return (
    <footer
      className={clsx(styles.alfredFooterRoot, {
        [styles.hidden]: shouldHide,
        [styles.fixed]: fixed,
        [styles.sticky]: !fixed,
      })}
    >
      <div className={styles.inputRegion}>
        <ChatInput
          config={{
            autoFocus: false,
            alfredEverywhere: true,
            allowedModes: ['document', 'research'],
          }}
          trackingMetadata={trackingMetadata}
        />
      </div>
    </footer>
  );
};
